export default "__VITE_ASSET__BN7412_g__"